import { isNullOrUndefined } from "utils";

import { CellColor } from "../styles/cellStyles";

export const getCellState = ({
  monthUsage,
  billType,
  hasNullUsage,
  isBeforeStart,
  isAfterEnd,
  isCurrentCellSelected,
  hasHistoricalData,
}: {
  monthUsage: number | null;
  billType: string;
  hasNullUsage: boolean;
  isBeforeStart: boolean;
  isAfterEnd: boolean;
  isCurrentCellSelected: boolean;
  hasHistoricalData: boolean;
}): { color: CellColor; showModal: boolean } => {
  if (
    hasHistoricalData
  ) {
    return {
      color: "deactivated",
      showModal: false,
    };
  }

  // Deactivated
  if (isBeforeStart || isAfterEnd) {
    return {
      color: "deactivated",
      showModal: false,
    };
  }

  // No data
  if (isNullOrUndefined(monthUsage)) {
    return {
      color: "error",
      showModal: true,
    };
  }

  // Partial data
  if (hasNullUsage) {
    return {
      color:
        isCurrentCellSelected
          ? "selected"
          : "warning",
      showModal: false
    };
  }

  // Interpolation - Extrapolation
  if (billType === "INTERPOLATION" || billType === "EXTRAPOLATION") {
    return {
      color:
        isCurrentCellSelected
          ? "selected"
          : "info",
      showModal: false,
    };
  }

  // Default
  return {
    color:
      isCurrentCellSelected
        ? "selected"
        : "none",
    showModal: false,
  };
};
